import Vue from 'vue'
import Vuex from 'vuex'

import ApplicationStore from './modules/ApplicationStore'
import EmailTemplateStore from './modules/EmailTemplateStore'
import QueryBuilderStore from './modules/QueryBuilderStore'
import EmailSenderStore from './modules/EmailSenderStore'
import EmailCampaignStore from './modules/EmailCampaignStore'
import DealerStore from './modules/DealerStore'
import UserStore from './modules/UserStore'
import CognitoAuth from './modules/vuex-cognito'
import ProfileStore from './modules/ProfileStore'
import DatasourceStore from './modules/DatasourceStore'
import S3FileStore from './modules/S3FileStore'
import CsvMappingStore from './modules/CsvMappingStore'
import CampaignConversionStats from './modules/CampaignConversionStats'
import CustomerAppendsStore from './modules/CustomerAppendsStore'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    ApplicationStore,
    EmailTemplateStore,
    QueryBuilderStore,
    EmailSenderStore,
    EmailCampaignStore,
    DealerStore,
    UserStore,
    ProfileStore,
    DatasourceStore,
    S3FileStore,
    CsvMappingStore,
    CampaignConversionStats,
    CustomerAppendsStore,
    cognito: new CognitoAuth({
      Region: process.env.VUE_APP_COGNITO_REGION,
      UserPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
      ClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
      IdentityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID
    })
  },
  getters: {
    // Get current user from Cognito state
    currentUser: (state) => {
      return state.cognito.user
    },
    
    // Check if user is super admin
    isAdmin: (state) => {
      const user = state.cognito.user
      if (!user || !user.tokens || !user.tokens.IdToken) {
        return false
      }
      
      try {
        const tokenPayload = JSON.parse(atob(user.tokens.IdToken.split('.')[1]))
        const groups = tokenPayload['cognito:groups'] || []
        return groups.includes('superadmin')
      } catch (error) {
        console.error('Error parsing JWT token:', error)
        return false
      }
    },
    
    // Check if user is account admin
    isAccountAdmin: (state) => {
      const user = state.cognito.user
      if (!user || !user.tokens || !user.tokens.IdToken) {
        return false
      }
      
      try {
        const tokenPayload = JSON.parse(atob(user.tokens.IdToken.split('.')[1]))
        const groups = tokenPayload['cognito:groups'] || []
        return groups.includes('accountadmin')
      } catch (error) {
        console.error('Error parsing JWT token:', error)
        return false
      }
    }
  }
})

export default store

export const useStore = () => store
